import React, { Component } from 'react';
import Select from './Select';
import Switch from './Switch';
import Editbox from './Editbox';

export default class Price_Timezone extends Component {
    constructor(props) {
        super(props);
    }

    handleChangeUnitPrice = (unit_price) => {
        this.setState({ unit_price: unit_price })
        this.props.handleChangeUnitPrice({ "unit_price": unit_price, "zone": this.props.zone, "type": this.props.type });
    }

    handleChangeName = (name) => {
        this.setState({ name: name })
        this.props.handleChangeName({ "name": name, "zone": this.props.zone, "type": this.props.type });
    }

    handleChangeStartTimeZone = (start_time_zone) => {

        //Check if start time zone is later then end time zone

        // Start time zone
        let start_time_zone_str = start_time_zone.replace(":", ""); //remove :
        while (start_time_zone_str.charAt(0) === '0') { //remove all the 0s
            start_time_zone_str = start_time_zone_str.substring(1);
        }
        let start_time_zone_num = 0;
        if (start_time_zone_str != "") start_time_zone_num = parseInt(start_time_zone_str);

        // End time zone
        let end_time_zone = this.state.end_time_zone.replace(":", ""); //remove :
        while (end_time_zone.charAt(0) === '0') { //remove all the 0s
            end_time_zone = end_time_zone.substring(1);
        }
        let end_time_zone_num = 0;
        if (end_time_zone != "") end_time_zone_num = parseInt(end_time_zone);

        //Compare Start Time Zone and End Time Zone
        if (start_time_zone_num < end_time_zone_num) {
            this.setState({ start_time_zone: start_time_zone })
        }

        this.props.handleChangeStartTimeZone({ "start_time_zone": start_time_zone_num, "zone": this.props.zone, "type": this.props.type });
    }

    handleChangeEndTimeZone = (end_time_zone) => {

        //Check if start time zone is later then end time zone

        // Start time zone
        let start_time_zone = this.state.start_time_zone.replace(":", ""); //remove :
        while (start_time_zone.charAt(0) === '0') { //remove all the 0s
            start_time_zone = start_time_zone.substring(1);
        }
        let start_time_zone_num = 0;
        if (start_time_zone != "") start_time_zone_num = parseInt(start_time_zone);

        // End time zone
        let end_time_zone_str = end_time_zone.replace(":", ""); //remove :
        while (end_time_zone_str.charAt(0) === '0') { //remove all the 0s
            end_time_zone_str = end_time_zone_str.substring(1);
        }
        let end_time_zone_num = 0;
        if (end_time_zone_str != "") end_time_zone_num = parseInt(end_time_zone_str);

        if (end_time_zone_num > start_time_zone_num) {
            this.setState({ end_time_zone: end_time_zone })
        }

        this.props.handleChangeEndTimeZone({ "end_time_zone": end_time_zone_num, "zone": this.props.zone, "type": this.props.type });

    }

    handleToggleSwitch = () => {
        let is_enabled_status = !this.state.is_enabled
        this.setState({ is_enabled: is_enabled_status })
        this.props.handleToggleSwitch({ "is_enabled": is_enabled_status, "zone": this.props.zone, "type": this.props.type });
    }

    render() {

        var x = 15; //minutes interval
        this.times = []; // time array
        var tt = 0; // start time
        var ap = ['AM', 'PM']; // AM-PM

        let unit_price = this.props.unit_price == null ? 0 : this.props.unit_price;
        let name = this.props.name == null ? '' : this.props.name;
        let start_time_zone = this.props.start_time_zone == null ? '0' : this.props.start_time_zone;
        let end_time_zone = this.props.end_time_zone == null ? '0' : this.props.end_time_zone;
        let is_enabled = this.props.is_enabled == null ? false : this.props.is_enabled;
        let priority = this.props.priority;

        //format time zones
        start_time_zone = "" + start_time_zone;
        end_time_zone = "" + end_time_zone;

        let start_time_length = start_time_zone.length;
        let end_time_length = end_time_zone.length;

        for (let j = 0; j < 4 - start_time_length; j++) {
            start_time_zone = "0" + start_time_zone; // result ->  0000
        }

        for (let j = 0; j < 4 - end_time_length; j++) {
            end_time_zone = "0" + end_time_zone; // result ->  0000
        }

        start_time_zone = start_time_zone.charAt(0) + start_time_zone.charAt(1) + ":" + start_time_zone.charAt(2) + start_time_zone.charAt(3); // result ->  00 : 00
        end_time_zone = end_time_zone.charAt(0) + end_time_zone.charAt(1) + ":" + end_time_zone.charAt(2) + end_time_zone.charAt(3); // result -> 00 : 00

        //loop to increment the time and push results in array
        for (var i = 0; tt < 24 * 60; i++) {
            var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
            var mm = (tt % 60); // getting minutes of the hour in 0-55 format
            let time_format = ("0" + hh).slice(-2) + ':' + ("0" + mm).slice(-2); // pushing data in array in [00:00 - 23:45 format] - 24 hours
            //let time_format  = ("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ap[Math.floor(hh/12)]; // pushing data in array in [00:00 - 12:00 AM/PM format] - 12 hours 
            this.times.push(<option selected value={time_format}>{time_format}</option>);
            //this.times[i] = ("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ap[Math.floor(hh/12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
            tt = tt + x;
        }
        this.times.push(<option selected value={'24:00'}>{'24:00'}</option>); //give user option to choose 24:00

        this.state = {
            name: name,
            unit_price: unit_price,
            start_time_zone: start_time_zone,
            end_time_zone: end_time_zone,
            is_enabled: is_enabled,
            priority: priority
        }

        // Define colors for each zone
        let color = "#FFFFFF";
        if (this.props.zone != null) {
            switch (this.props.zone) {
                case 'zone1':
                    color = "#FF0000";
                    break;
                case 'zone2':
                    color = "#FFFF00";
                    break;
                case 'zone3':
                    color = "#4169E1";
                    break;
                case 'zone4':
                    color = "#00FF00";
                    break;
                case 'zone5':
                    color = "#FFE4E1";
                    break;
            }
        }

        return (
            <div style={{ width: '90%', display: 'flex', marginLeft: 20, marginTop: 10, marginBottom: 10, height: 130 }}>
                <div style={{ width: '20%', display: 'inline-block', border: 'black', borderWidth: 'thin', borderStyle: 'solid' }}>
                    {/* Zone priority */}
                    <span id='priority' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '33%', textAlign: 'center' }}>{this.props.priority}</span>
                    {/* Zone enability */}
                    <Switch id='enable' style={{ height: '33%', marginTop: 10, }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleSwitch} />
                    {/* Zone color indicator */}
                    <div id='color' style={{ height: '33%', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ borderRadius: 200, background: color, width: 10, height: 10 }}></div>
                    </div>
                </div>
                <div id='time_zone' style={{ width: '50%', display: 'inline-block', padding: 10, border: 'black', borderWidth: 'thin', borderStyle: 'solid', borderLeft: 'none', borderRight: 'none' }}>
                    {/* Zone name input */}
                    <Editbox id={this.props.type + '_' + this.props.zone} style={{ margin: 'auto' }} placeholder={this.props.name_placeholder} inputType='text' onChange={(event) => this.handleChangeName(event.target.value)} value={this.state.name} />
                    <div style={{ marginTop: 10 }}>
                        {/* Start Timezone */}
                        <div style={{ display: 'inline-block' }}>
                            <Select
                                options={this.times}
                                value={this.state.start_time_zone}
                                onSelect={this.handleChangeStartTimeZone}
                            />
                        </div>
                        <div style={{ display: 'inline-block', marginLeft: 5, marginRight: 5 }}>
                            <span>{"-"}</span>
                        </div>
                        {/* End Timezone */}
                        <div style={{ display: 'inline-block' }}>
                            <Select
                                options={this.times}
                                value={this.state.end_time_zone}
                                onSelect={this.handleChangeEndTimeZone}
                            />
                        </div>
                    </div>
                </div>
                <div id='unit_price' style={{ width: '30%', display: 'inline-block', padding: 10, border: 'black', borderWidth: 'thin', borderStyle: 'solid' }}>
                    {/* Unit Price */}
                    <Editbox id={'unit_price_' + this.props.type + '_' + this.props.zone} style={{ margin: 'auto', height: '50%' }} inputType='number' onChange={(event) => this.handleChangeUnitPrice(event.target.value)} value={this.state.unit_price} />
                    {/* Currency */}
                    <div style={{ display: 'flex', height: '50%', justifyContent: 'center', alignItems: 'center', marginTop: 10, overflow: 'auto' }}>
                        <span style={{ width: '100%', height: '100%' }}>{this.props.currency}/kWh</span>
                    </div>
                </div>
            </div>

        )
    }

}

